import { render } from "./CurrencyText.vue?vue&type=template&id=008bf27b&ts=true"
import script from "./CurrencyText.vue?vue&type=script&lang=ts"
export * from "./CurrencyText.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__